import { render } from "./vgpScrollBar.vue?vue&type=template&id=49a86278&scoped=true"
import script from "./vgpScrollBar.vue?vue&type=script&lang=js"
export * from "./vgpScrollBar.vue?vue&type=script&lang=js"

import "./vgpScrollBar.vue?vue&type=style&index=0&id=49a86278&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a86278"]])

export default __exports__